export default "__VITE_ASSET__bb0591e6__"